import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { CreditCardPayments } from "./CreditCardPayments"
import { Agreement } from "../../../settings/posAcquirer/SupplierAdminPOSTypes"
import { BankAccountDetails, SubscriptionDetailsInfo } from "../supplierMerchantsTypes"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { MerchantMainInfo } from "../../../../../merchant/admin/account/merchantAccount/components/MerchantMainInfo"
import { MerchantContactDetails } from "../../../../../merchant/admin/account/merchantAccount/components/MerchantContactDetails"
import { OpeningHoursAsideWrapper } from "../../../../../merchant/admin/account/merchantAccount/components/OpeningHours/OpenigHoursAsideWrapper"
import { EntityHistory } from "../../../../../support/admin/entities/supportEntitiesTypes"
import { EntitySubscriptionStatus } from "./EntitySubscriptionStatus"
import { UserType } from "../../../../../login/loginTypes"
import { MatchActualUserType } from "../../../../../accessControl/MatchActualUserType"

type CreateUpdateMerchantFormContentProps = Readonly<{
    isShowPayments: boolean
    paymentList: Agreement[]
    bankAccountDetails?: BankAccountDetails
    history?: EntityHistory
    subscriptionDetails?: SubscriptionDetailsInfo
}>
export function CreateUpdateMerchantFormContent({
    isShowPayments,
    paymentList,
    bankAccountDetails,
    history,
    subscriptionDetails,
}: CreateUpdateMerchantFormContentProps) {
    return (
        <StandardForm>
            <StandardMainPanel>
                <MerchantMainInfo />
            </StandardMainPanel>
            <LocalizedStrict id="create-or-edit-supplier-admin-merchant-contact-details-title" attrs={{ title: true }}>
                <StandardMainPanel variant="collapsible" title="Contact details">
                    <MerchantContactDetails />
                </StandardMainPanel>
            </LocalizedStrict>
            {isShowPayments && (
                <LocalizedStrict
                    id="create-or-edit-supplier-admin-merchant-credit-card-payments-title"
                    attrs={{ title: true }}
                >
                    <StandardSidePanel variant="collapsible" title="Credit card payments">
                        <CreditCardPayments paymentList={paymentList} bankAccountDetails={bankAccountDetails} />
                    </StandardSidePanel>
                </LocalizedStrict>
            )}
            <LocalizedStrict id="merchant-update-account-opening-hours-title" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Opening hours">
                    <OpeningHoursAsideWrapper />
                </StandardSidePanel>
            </LocalizedStrict>
            {subscriptionDetails && history && (
                <MatchActualUserType userTypes={[UserType.SUPPORT]}>
                    <LocalizedStrict id="support-create-subscription-status-title" attrs={{ title: true }}>
                        <StandardSidePanel variant="collapsible" title="Subscription status">
                            <EntitySubscriptionStatus subscriptionDetails={subscriptionDetails} history={history} />
                        </StandardSidePanel>
                    </LocalizedStrict>
                </MatchActualUserType>
            )}
        </StandardForm>
    )
}

